




























import { computed, defineComponent } from "@vue/composition-api";
import { formatDate, getNow } from "@/lib/time";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseChip from "@/components/BaseChip";

export default defineComponent({
  name: "MassMessageScheduledOption",
  components: { BaseChip, BaseIcon },
  props: {
    show: { type: Boolean, default: true },
    scheduledTime: { type: String },
  },
  setup(props) {
    const publishTime = computed(() => {
      const time = props.scheduledTime;
      if (!time) return null;
      const date = new Date(time);
      if (date.getTime() <= getNow().getTime()) return null;

      return formatDate(new Date(time), {
        month: "2-digit",
        day: "2-digit",
        year: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
    });

    return {
      publishTime,
    };
  },
});
